module.exports = __webpack_public_path__ + "static/media/news-page1.d1ec2eca.jpg";